import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { BaseURL, uniqueToken, GpsBaseURL, Role } from "../../api/DataApis";
import Select from 'react-select';
function Edit(props) {
  document.title = "Users | Edit";
  const navigate = useNavigate();
  const location = useLocation();
  const UserEditData = location?.state?.UserEditData;


  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [VehicleNumber, setVehicleNumber] = useState("");
  const [selectedParent, setselectedParent] = useState("");
  const [userType, setUserType] = useState("");
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [Address, setAddress] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({ _id: '', id:'' });
  const [selectedState, setSelectedState] = useState({ _id: '', name: '' });
  const [selectedCity, setSelectedCity] = useState('');
  const [Users, setUsers] = useState({});
  const [loading, setLoading] = useState(false);
  const [Imageurl, setImageurl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  
  const [filteredData, setFilteredData] = useState([]);
  const [loadings, setLoadings] = useState(false);
  const [selectedCorporate, setSelectedCorporate] = useState([]);
  const [bcorporateName, setbcorporateName] = useState("");
   const [DistrictName, setDistrictName] = useState("");
   const [PinCode, setPincode] = useState("");
   const [bcAgentID, setbcAgentID] = useState("");
  
   const handleBCCorporateName  = (e) => {
    setbcorporateName(e.target.value);
  }
  const handlePinCode = (e) => {
    setPincode(e.target.value);
  }
  const handleDistrictName = (e) => {
    setDistrictName(e.target.value);
  }
  const handlebcAgentID = (e) => {
    setbcAgentID(e.target.value);
  }


  const fetchData = async () => {
    const apiEndpoint = `${GpsBaseURL}/user/detail/${UserEditData?._id}`;
  
    setLoading(true); // Set loading to true before fetching
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      if (res && res.data?.user) {
        setUsers(res?.data?.user);
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);


  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleNameChange = (e) =>{ 
    e.preventDefault()
    setName(e.target.value);}
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleCityChange = (e) => setSelectedCity(e.target.value);


//   const handlecorporateChange = (selectedOption) => {
//     console.log("selectedOption3wrewgfreh", selectedOption);
//     if(selectedOption) {
//    setSelectedCorporate(selectedOption._id);
//     } else {
//       setSelectedCorporate(null); 
//   }
// }
const handlecorporateChange = (selectedOptions) => {
  setSelectedCorporate(selectedOptions ? selectedOptions.map(option => option.value) : []);
};

 

  const fetchCorporate = async (page) => {
   
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/corporate`);
   
    
 try {
      const response = await axios.get(apiEndpoint, {
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
        },
      });
  
      console.log("response", response);
  
      setFilteredData(response.data?.data);
    // Assuming API returns totalCount for pagination
    } catch (error) {
      console.error("Error fetching users:", error);
    } 
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchCorporate();
  }, []);

  const corporateOptions = filteredData?.map(corporate => ({
    value: corporate._id,
    label: `${corporate.corporate_name} (${corporate?.email})`,
    _id: corporate._id,
  }));



  const handleSelectFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      // Create a URL for the selected file and set it to state
      const imageUrl = URL.createObjectURL(file);
      setImageurl(imageUrl);
      setSelectedFile(file);
    }
  };
  
    // setImageurl(e.target.files[0])};
  const handleStatusChange = (e) => setSelectedStatusType(e.target.value);

 
  const handleMobileChange =(e) => {
    setMobile(e.target.value);
  }

  const handleCountryChange = (e) => {
    // const selectedOptionKey = e.target.options[e.target.selectedIndex];
    // const country_id = selectedOptionKey.getAttribute('data-key');

    const countryId = e.target.value;

    const selectedOption = countries.find(country => country._id === countryId );
    //console.log("---selectedOption--", selectedOption);
    setSelectedCountry({ _id: selectedOption._id, id: selectedOption.id });
  };
  
  const handleStateChange = (e) => {
  const selectedOption = states.find(state => state.id === e.target.value);
  setSelectedState({ _id: selectedOption._id, id: selectedOption.id });
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${GpsBaseURL}/settings/countries`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry.id) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(`${GpsBaseURL}/settings/states/${selectedCountry.id}`, {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
          setStates(response.data.data.data);
          setCities([]);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry.id]);
  console.log("selectedState.id", selectedState.id);

  const fetchCities = async () => {
    if (selectedState.id) {
      try {
        const response = await axios.get(`${GpsBaseURL}/settings/cities/${selectedState.id}`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Cities API Response:", response.data); 
        if (response.data && response.data.data) {
          setCities(response.data.data.data);
        } else {
          console.warn("No cities data found in response:", response);
          setCities([]); // Clear the cities if response is empty
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]); // Clear the cities in case of error
      }
    }
  };
  useEffect(() => {
    fetchCities(); // Ensure this function is called when selectedState.id changes
  }, [selectedState.id]);

  useEffect(() => {
    if (Users) {
      // Set the input fields with the fetched user data
      setName(Users?.name || "");
      setMobile(Users?.mobile || "");
      setEmail(Users?.email || "");
      if(Users?.corporate_id) {
      setSelectedCorporate(Users?.corporate_id[0]);
      }
      setDistrictName(Users?.district);
      setPincode(Users?.pin_code);
      setbcAgentID(Users?.bc_agent_id);
      setbcorporateName(Users?.bc_corporate_name);
      setselectedParent(Users?.parent || "");
      setAddress(Users?.address || "");
      setUserType(Users?.userType || "");
     
    
      
  
      // Only set the country, state, and city once after fetching data
      if (!selectedCountry._id && Users?.countryId) {
        const country = countries.find(c => c._id === Users?.countryId[0]);
        if (country) {
          setSelectedCountry({ _id: country._id, id: country.id });
        }
      }
  
      if (!selectedState._id && Users?.stateId) {
        const state = states.find(s => s._id === Users?.stateId[0]);
        if (state) {
          setSelectedState({ _id: state._id, id: state.id });
        }
      }
  
      if (!selectedCity && Users?.cityId) {
        const city = cities.find(c => c._id === Users?.cityId[0]);
        if (city) {
          setSelectedCity(city._id);
        }
      }
    }
  }, [Users]);
  useEffect(() => {
   
    setImageurl(Users?.imageURL || null);
      
    },
   [Users]);
  
  

  const EditUser = async (UserEditData) => {
    if (!UserEditData || !UserEditData._id) {
      console.error("User ID is missing or UserEditData is invalid");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "User ID is missing.",
      });
      return;
    }
        if (!selectedCorporate && Role === "false") {
              Swal.close(); // Close the loader before showing the error message
              Swal.fire({
                icon: "error",
                title: "Validation Error",
                text: "Please select a Corporate before proceeding.",
              });
              return; // Stop further execution
            }

    let formData = new FormData();
    formData.append("name", Name);
    formData.append("address", Address);
    formData.append("mobile", Mobile);
    formData.append("email", Email);
    // formData.append("status", selectedStatusType);
   formData.append("countryId", selectedCountry._id);
    formData.append("stateId", selectedState._id);
    formData.append("cityId", selectedCity);
    formData.append("district", DistrictName);
    formData.append("pin_code", PinCode);
    formData.append("bc_corporate_name", bcorporateName);
    formData.append("bc_agent_id", bcAgentID);

    if (selectedFile) {
      formData.append("profile_image", selectedFile);
    }
    // if(selectedCorporate) {
    //   formData.append("corporate_id", selectedCorporate);
    // }
    if (Array.isArray(selectedCorporate) && selectedCorporate.length > 0) {
      selectedCorporate.forEach((corporateId) => {
        formData.append("corporate_id[]", corporateId);
      });
    }
        
 

    try {
      Swal.fire({
        title: 'Processing...',
        text: 'please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let response = await fetch(`${GpsBaseURL}/user/edit/${UserEditData._id}`, {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      let responseData = await response.json();
Swal.close();
      if (responseData.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "User updated successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/usermanagement/users`);
      } else {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${responseData?.message}`,
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Error in EditUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message,
      });
    }
  };
  console.log("users", Users);


  return (
    <div className="container-fluid">
          {loading ? (
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    ) : (

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <h1 className="page-title"></h1>
            <div className="portlet light bordered">
              <div className="portlet-title row">
                <div className="caption font-dark col-md-10">
   
                  <h4 className="caption-subject bold uppercase mx-3">Edit Users</h4>
                </div>
                <div className="caption font-dark col-md-2">
                  <h5 className="caption-subject bold uppercase mx-3">
                    <button className="btn btn-success" onClick={() => navigate(-1)}>Back</button>
                  </h5>
                </div>
              </div>
              <div className="portlet-body mx-3">
                <hr style={{ marginTop: ""}} />
                <div className="row">
                  <div className="col-sm-12">
                    <form className="form-horizontal" encType="multipart/form-data" role="form" method="post" style={{ marginTop: "-20px" }}>
                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="name_id" className="col-sm-2 control-label"> Name</label>
                          <div className="col-sm-6">
                            <input onChange={handleNameChange} value={Name} className="form-control" id="name_id" />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="latitude_id" className="col-sm-2 control-label">Mobile</label>
                          <div className="col-sm-6">
                            <input onChange={handleMobileChange} className="form-control" id="latitude_id" value={Mobile} />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="email_id" className="col-sm-2 control-label">Email</label>
                          <div className="col-sm-6">
                            <input onChange={handleEmailChange} className="form-control" id="email_id" value={Email} />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>
                     
                       <div className="form-group">
                        <div className="row">
                          <label htmlFor="country_id" className="col-sm-2 control-label">Select Country</label>
                          <div className="col-sm-6">
                            <select onChange={handleCountryChange} className="form-control" value={selectedCountry._id || ""}>
                              <option value="">Select Country</option>
                              {countries.map((country) => (
                                <option key={country._id} value={country._id} data-key={country.id}>
                                  {country.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="state_id" className="col-sm-2 control-label">Select State</label>
                          <div className="col-sm-6">
                            <select onChange={handleStateChange} className="form-control" value={selectedState.id}>
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option key={state._id} value={state.id}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="city_id" className="col-sm-2 control-label">Select City</label>
                          <div className="col-sm-6">
                            <select onChange={(e) => setSelectedCity(e.target.value)} className="form-control" value={selectedCity}>
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option key={city._id} value={city._id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="address_id" className="col-sm-2 control-label">Address</label>
                          <div className="col-sm-6">
                            <textarea onChange={handleAddressChange} className="form-control" id="address_id" value={Address} />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            BC Corporate Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleBCCorporateName}
                                value={bcorporateName}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            BC Agent ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlebcAgentID}
                                value={bcAgentID}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            District
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleDistrictName}
                                value={DistrictName}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                            Pin Code
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePinCode}
                                value={PinCode}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Select Corporate
                            </label>
                            <div className="col-sm-6">
                            <Select
                              options={corporateOptions}
                              onChange={handlecorporateChange}
                              //value={selectedCorporate ? corporateOptions?.find(option => option.value === selectedCorporate) : null}
                              value={corporateOptions?.filter(option => selectedCorporate.includes(option.value))} // Filter selected values
                              placeholder="Select Corporate"
                              isClearable
                              isMulti  // <-- Enable multi-select
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  height: '38px', 
                                  width: '100%',
                                  boxShadow: 'none',
                                  minWidth: '0',
                                  flex: 1,
                                }),
                              }}
                            />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="profile_image" className="col-sm-2 control-label">Profile Image</label>
                          <div className="col-sm-6">
                            <input type="file" onChange={handleSelectFileChange} className="form-control" id="profile_image" />
                          </div>
                          <div className="col-sm-4 control-label">
            {/* Show image preview if an existing image URL is available */}
            {Imageurl && typeof Imageurl === 'string' && (
              <img
                src={Imageurl} // Use the image URL for src
                alt="Current Category"
                style={{ width: '100px', height: '100px', objectFit: 'cover', marginLeft: "180px" }}
              />
            )}
             </div>
               </div>
                      </div>
                        <div className="form-group">
                        <div className="row">
                          <div className="col-sm-12 text-center">
                            <button type="button" onClick={() => EditUser(UserEditData)} className="btn btn-primary">Update</button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        )}
    </div>
  );
}

export default Edit;
